import {connect} from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import {InstanceAPIs, Instances} from '../../../../../constants';
import {IStateType} from '../../../../../store/models/root.interface';
import {closeSideBar, getParams} from '../../../../../store/sidebar';
import { removeObjects, updateObjects} from '../../../../../store/Objects';

import AddUserGroupModal, {MapDispatchToPropsType, MapStateToPropsType} from '../organisms/AddUserGroupModal';
import {makeSelectInProgress, makeSelectObject, removeObject, requestObject} from "../../../../../store/Object";

const mapStateToProps = (state: IStateType) => {
    const params = getParams(state);
    const selectBridgeNumbers = makeSelectObject(Instances.BridgeNumbers);
    const selectBridgeNumberInProgress = makeSelectInProgress(Instances.BridgeNumbers);
    return {
        params,
        bridgeNumbers: selectBridgeNumbers(state),
        bridgeNumberInProgress: selectBridgeNumberInProgress(state)
    };
};

const mapDispatchToProps = {
    closeModal: () => closeSideBar([removeObject(Instances.BridgeNumbers)]),
    getBridgeNumbers: (params:any) => requestObject(Instances.BridgeNumbers,params),
    addUserGroup: (reqData: any, cb?: (res: any, success: boolean)=> void) =>  updateObjects(Instances.UserGroup, "POST", reqData, undefined, undefined, undefined, undefined, undefined, cb, "", InstanceAPIs[Instances.UserGroup].POST),
    removeSipCredentialInstance: () =>  removeObjects(Instances.SipCredential),
    removeUserGroupInstance: () =>  removeObjects(Instances.UserGroup),
    addSipCredential: (reqData: any,filters:any, dynamicUrlData:string, cb?: (res: any, success: boolean)=> void) =>  updateObjects(Instances.SipCredential, "POST", reqData, filters, undefined, undefined, undefined, undefined, cb, dynamicUrlData, InstanceAPIs[Instances.SipCredential].POST),
};

export default connect<MapStateToPropsType, MapDispatchToPropsType, unknown, IStateType>(
    mapStateToProps,
    mapDispatchToProps
)(withImmutablePropsToJS(AddUserGroupModal));
